import { module } from 'modujs';
import Emitter from "tiny-emitter/instance";


export default class extends module {

    constructor(m) {
        super(m);
        this.events = { click: { 'option': 'onSelect' }, mouseenter: { 'option': 'onMouseEnter' } };
        this.select = this.el.querySelector( 'select' );
        this.isMultiple = this.select.multiple;



        this.error = this.el.querySelector( '[data-error]' );
        this.error.textContent = this.error.dataset.errorMsg;
        this.el.addEventListener( 'click', this.onClick.bind( this ) );
        this.select.addEventListener( 'update', this.onUpdate.bind( this ) );
        this.select.addEventListener( 'click', e => e.stopPropagation() );

        this.input = this.$( 'input' )[0];
        if(this.input){
            this.input.addEventListener( 'click', e => e.stopPropagation() );
            this.input.addEventListener( 'keyup', this.onKeyup.bind( this ) );
            this.input.addEventListener( 'keydown', e => { if( e.key === 'Enter' ) e.preventDefault(); } );
            this.input.addEventListener( 'input', this.setHeight.bind( this ) );
        }


        Emitter.on('click-outside', this.onBlur.bind( this ) );
        this.onMouseEnter( { currentTarget : this.$( 'option' )[0] });
        this.selected = this.el.querySelector('[data-my-custom-select="option"].selected');

        this.bg= this.$( 'bg' )[0];

        this.pillTemplate = this.$( 'pill' )[0];
        this.placeholder = this.$( 'placeholder' )[0];
        this.pillsCount = 0;

        this.hasClicked = false;

        Emitter.on( 'reset-custom-select', this.resetCustomSelect.bind( this ) );

    }

    onUpdate( e ){

        if( e.detail.value ){
            let option = this.el.querySelector('[data-my-custom-select="option"][data-value="' + e.detail.value  + '"]');
            if( option ) option.click();
        }
    }

    resetCustomSelect() {
        this.placeholder.textContent = this.placeholder.dataset.default;
        this.select.value = '';
        this.hasClicked = false;
        this.onBlur();
        this.el.classList.remove( 'error' );
    }

    init(){

        new ResizeObserver(() => { this.setHeight() }).observe(this.el);

        [...this.el.querySelectorAll('[data-my-custom-select="option"].selected')].forEach( selected => {
            this.onSelect( { currentTarget : selected });
        });


        if( ! this.el.dataset.maxOptions || this.$( 'option' ).length <= parseFloat( this.el.dataset.maxOptions ) ) return;
        this.maxOptions = parseFloat( this.el.dataset.maxOptions );
        this.onResize();
        this.onResizeBind = this.onResize.bind( this );
        window.addEventListener( 'resize', this.onResizeBind );
        this.setHeight();
    }


    onClick( e ){
        e.stopPropagation();
        if( e ) this.hasClicked = true;
        this.el.classList.toggle( 'focus' );
        this.el.classList.toggle( 'z-10' );
        if( this.el.classList.contains( 'focus') && this.input ){
            this.input.focus();
        }
        this.setHeight();
        Emitter.emit('click-outside', this.el );
    }

    setHeight(){
        this.bg.style.height = this.$( 'selection' )[0].getBoundingClientRect().height + this.$( 'dropdown' )[0].getBoundingClientRect().height +  'px';
        this.call( 'update', false, 'Scroll');
    }

    onBlur( e ) {
        if ( e === this.el ) return;
        if( this.hasClicked ) this.validate();
        if( this.el.classList.contains( 'focus' ) ){
            this.el.classList.remove( 'focus' );
            this.el.classList.remove( 'z-10' );
            this.bg.style.height = '100%';
            if( this.input) this.input.value = '';
            this.$( 'option' ).forEach( option => option.classList.remove( 'hidden' ) );
        }

        this.select.querySelector( 'option[value=""]').selected = false;
        if( ! this.select.selectedOptions.length ){
            this.select.querySelector( 'option[value=""]').selected = 'selected';
        } else {
            this.select.querySelector( 'option[value=""]').selected = false;
        }


        this.el.classList.toggle( 'has-value', this.select.value);
    }


    onSelect( e ){
        this.call( 'start', false, 'Scroll' );
        if( ! this.isMultiple ) {

            this.$( 'placeholder' )[0].textContent = e.currentTarget.dataset.text;
            if( this.selected ){
                this.selected.classList.remove( 'selected' );
            }
            this.selected = this.hovered = e.currentTarget;
            this.selected.classList.add( 'selected' );

            this.select.value = this.selected.dataset.value;
            this.select.dispatchEvent(new Event('change'));
            this.onBlur();
        } else {

            this.selected = this.hovered = e.currentTarget;
            this.selected.classList.add( '!hidden' );
            this.createPill( e.currentTarget );
            this.input.value = '';
            this.select.querySelector( 'option[value="' + this.selected.dataset.value + '"]').selected = true ;
            this.filterResults();
            this.setHeight();

        }
        this.validate();
    }

    createPill( option ){
        let pill = this.pillTemplate.cloneNode( true );
        pill.classList.remove( 'hidden' );
        pill.querySelector( '[data-pill-text]' ).textContent = option.dataset.text;
        pill.querySelector( '[data-pill-remove]' ).addEventListener( 'click', e => {
            e.stopPropagation();
            pill.remove();
            option.classList.remove( '!hidden' );
            this.pillsCount--;
            this.placeholder.classList.toggle( 'hidden', this.pillsCount );
            this.select.querySelector( 'option[value="' + option.dataset.value + '"]').selected = '';

            this.setHeight();
        });

        this.$( 'pills' )[0].append( pill );
        this.pillsCount++;
        this.placeholder.classList.add( 'hidden' );
    }

    onMouseEnter( e ){
        if( this.hovered ){
            this.hovered.classList.remove( 'hovered' );
        }
        this.hovered = e.currentTarget;
        this.hovered.classList.add( 'hovered' );
        Emitter.emit('scroll-to', { container : this.$( 'options' )[0] , el : this.hovered  });

    }

    validate(){
        if( ! this.el.dataset.validateSelect ) return true;
        let isHiddenField = this.el.closest( '[data-toggle-field-display-target]' );
        if( isHiddenField && isHiddenField.classList.contains( 'hidden' ) ) return true;
        if( this.select.querySelector( 'option[value=""]').selected ) {
            this.isValid = false;
        } else {
            this.isValid = this.select.selectedOptions.length;
        }
        this.el.classList.toggle( 'error', ! this.isValid );
        this.call( 'update', false, 'Scroll');
        return this.isValid;
    }

    onResize(){
        let clone = this.el.querySelector( '[data-my-custom-select="option"]:not(.selected)' ).cloneNode( true );
        clone.style.position = 'absolute';
        clone.style.top = '-1000px';
        document.body.append( clone );
        this.$( 'options' )[0].style.maxHeight = this.maxOptions * clone.getBoundingClientRect().height + 'px';
        clone.remove();
        this.setHeight();
    }

    onKeyup( e ){
        if( e.key === 'Escape') this.onBlur();
        else if( e.key === 'Enter') {
            e.preventDefault();
            this.hovered.click();
        }
        else if ( e.key === 'ArrowDown' ){
            let nextSibling = this.hovered.nextSibling;
            while( nextSibling && nextSibling.nodeType !== 1)  nextSibling = nextSibling.nextSibling;
            this.onMouseEnter( { currentTarget : nextSibling || this.$( 'option' )[0] })
        }
        else if ( e.key === 'ArrowUp' ){
            let previousSibling = this.hovered.previousSibling;
            while( previousSibling && previousSibling.nodeType !== 1) previousSibling = previousSibling.previousSibling;
            this.onMouseEnter( { currentTarget : previousSibling || this.$( 'option' )[ this.$( 'option' ).length - 1 ] })
        } else {
            this.filterResults();
        }
        this.setHeight();
    }

    filterResults(){
        let foundOne = false;
        this.$( 'option' ).forEach( option => {
            let matches = option.dataset.text.toUpperCase().includes( this.input.value.toUpperCase() );
            option.classList.toggle( 'hidden', ! matches );
            if( matches && ! foundOne ){
                foundOne = true;
                this.onMouseEnter( { currentTarget : option } );
            }
        } );
    }

    destroy(){
        window.removeEventListener( 'resize', this.onResizeBind );
    }

}
